// Include jQuery
const $ = require('jquery');

// jQuery Definitionen
window.jQuery = $;
window.$ = $;

// Include Helpers
require('./helper/functions');
require('./helper/helper');
require('./helper/login');
require('./helper/contextMenu');
require('./helper/accordion');
require('./helper/foldbox');
require('./helper/tree-item');
require('./helper/autocomplete');
require('./helper/updateRowtableSticky');
require('./helper/highcharts');

// Include Aufzeichnungen
require('./aufzeichnungen/aufzeichnungen');
require('./aufzeichnungen/splitAufzeichnungen');
if (MODULE_PATH === 'aufzeichnungen') {
  if (MODULE_FILE === 'spritzung') {
    // Spritzung
    require('./aufzeichnungen/spritzung/spritzung');
  } else if (MODULE_FILE === 'duengung') {
    // Duengung
    require('./aufzeichnungen/duengung/duengung');
  } else if (MODULE_FILE === 'herbizidBehandlung') {
    // HerbizidBehandlung
    require('./aufzeichnungen/herbizidBehandlung/herbizidBehandlung');
  } else if (MODULE_FILE === 'verwirrung') {
    // Verwirrung
    require('./aufzeichnungen/verwirrung/verwirrung');
  } else if (MODULE_FILE === 'andereMassnahmen') {
    // AndereMassnahmen
    require('./aufzeichnungen/andereMassnahmen/andereMassnahmen');
  } else if (MODULE_FILE === 'feldkontrollen') {
    // Feldkontrollen
    require('./aufzeichnungen/feldkontrollen/feldkontrollen');
  } else if (MODULE_FILE === 'pheromonfallen') {
    // Pheromonfallen
    require('./aufzeichnungen/pheromonfallen/pheromonfallen');
  } else if (MODULE_FILE === 'bewaesserung') {
    // Bewaesserung
    require('./aufzeichnungen/bewaesserung/bewaesserung');
  }
}

// Includes
require('./uebersicht/uebersicht');

// Include Vegetation & Ernte
require('./vegetationErnte/geschaetzteErtraege');
require('./vegetationErnte/ernte');
require('./vegetationErnte/vegetationErnte');
require('./vegetationErnte/oekologischeMassnahmen');
require('./vegetationErnte/feldkontrollen');
require('./vegetationErnte/voraussichtlicheErntetermine');

// Include Lager
require('./lager/lagerArchiv');
require('./lager/lagerbestaende');
require('./lager/lagerListen');
require('./lager/lagerEinkauf');
require('./lager/lagerEntsorgung');
require('./lager/lagerBestandskorrektur');
require('./lager/lagerInventur');
require('./lager/lagerLieferant');

// Include Betriebsdaten
require('./betriebsdaten/betriebsdaten');
require('./betriebsdaten/betriebeAnlagen');
require('./betriebsdaten/betriebeDetails');
require('./betriebsdaten/betriebeImport');
require('./betriebsdaten/anlagenDetails');
require('./betriebsdaten/abschnitteEdit');
require('./betriebsdaten/arbeitsmittel');
require('./betriebsdaten/berechnungBruehmenge');
require('./betriebsdaten/berechnungBrueheHerbizid');
require('./betriebsdaten/betriebsleiterMitarbeiter');
require('./betriebsdaten/bewaesserungsanlagen');
require('./betriebsdaten/bewaesserungsanlagenEdit');
require('./betriebsdaten/bewaesserungssystem');
require('./betriebsdaten/flaechenVerwalten');

// Include Druck/Abgabe
require('./druckAbgabe/digitaleAbgabe');
require('./druckAbgabe/bewaesserungsanlage');
require('./druckAbgabe/geraete');

// Include Administration
if (MODULE_PATH === 'administration') {
  require('./administration/abgaben');
}

// Document Ready
$(function() {
  // Init Password Toggle
  initPasswordToggle();

  // tooltip
  initTooltip();

  // Init Accordion
  const accordionGroups = $('.accordion');
  if (accordionGroups.length) {
    accordionGroups.each(function() {
      initAccordion($(this));
    });
  }

  initFoldbox();

  // user nav overlays
  $(document).on('click', function(e) {
    // Prevent closing the menu by clicking these elements
    const container = $('.special-menu');

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.removeClass('clicked');
    } else {
      if ($(e.target).hasClass('current') && $(e.target).closest('.special-menu').hasClass('clicked')) {
        // Aktuelles Menü schließen (bereits geöffnetes Menü schließen)
        $(e.target).closest('.special-menu').removeClass('clicked');
      } else if ($(e.target).hasClass('current')) {
        // Andere Menüs schließen und geklicktes neu öffnen (das menü war noch nicht offen)
        container.each(function() {
          $(this).removeClass('clicked');
        });
        $(e.target).closest('.special-menu').addClass('clicked');
      }
    }
  });

  // mobile menu overlay
  $('#app_menu-button').on('click', function() {
    $('#app').toggleClass('app--menu-open');
  });
  $('#app__navigation__overlay').on('click', function() {
    $('#app').removeClass('app--menu-open');
  });

  // add overlay
  $('#app_add-button:not(.no-addmenu)').on('click', function() {
    $('#app').toggleClass('app--add-open');
  });
  $('#add__popup-bg').on('click', function() {
    $('#app').removeClass('app--add-open');
  });

  // Init Search-Field
  initSearchField();

  // Input type number min/max
  inputNumberMinMax();

  // row-table sticky update top
  updateRowtableSticky();

  // check if date is supported
  if (!isDateSupported()) {
    loadJs(BASE_PATH + 'assets/js/src/plugins/configurable-date-input-polyfill.dist.js', document.body);
    loadJs(BASE_PATH + 'assets/js/src/plugins/time-input-polyfill.min.js', document.body);
  }
});

// KeyDown
$(document).on('keydown', function(e) {
  if (e.key === 'Escape') {
    let popupWrap = [];
    $('body').find('.modal').each(function() {
      popupWrap.push($(this));
    });

    const lastItem = popupWrap.pop();

    // Beim Drücken von ESC das letzte Popup schließen
    if (typeof lastItem !== 'undefined' && lastItem.length) {
      if (typeof overwriteClose == 'function') {
        overwriteClose();
      }

      const popUpWrap = $('body .modal');
      popUpWrap.last().remove();
      if ($('body .modal ').length === 0) {
        $('body .modal-backdrop').remove();
      }

      checkOpenDialog();
      return false;
    }
  }
});

// Ajax Running
$(document).ajaxStart(function() {
  AjAX_RUNNING = true;
});

document.addEventListener('DOMContentLoaded', function() {
  iOSInputFix();
});